import React from "react";
import { LuChevronRight } from "react-icons/lu";
import DeleteAccountIcon from "../../icons/DeleteAccountIcon";
import { translateText, useTranslationSnapshot } from "./../../translations/runtime";


const accountSettingsItems = [
  {
    key: "user-info",
    title: "User Information",
    subtitle: "View your personal information and edit your profile picture.",
  },
  {
    key: "account-access",
    title: "Account Access",
    subtitle: "Update or change your email, phone number or password.",
  },
  {
    key: "address",
    title: "Address",
    subtitle: "Edit your residential information.",
  },
];

function AccountSettingsTile({ onClick, subtitle, title }) {
  useTranslationSnapshot();
  return (
    <button
      className="vendor-account-settings-tile"
      type="button"
      onClick={onClick}
    >
      <span>
        <strong>{translateText(title)}</strong>
        <small>{translateText(subtitle)}</small>
      </span>
      <LuChevronRight className="navigation-direction-icon" aria-hidden="true" />
    </button>
  );
}

function AccountSettingsHome({ onSelect }) {
  useTranslationSnapshot();
  return (
    <>
      <div className="vendor-account-settings-menu">
        {accountSettingsItems.map((item) => (
          <AccountSettingsTile
            key={item.key}
            title={translateText(item.title)}
            subtitle={translateText(item.subtitle)}
            onClick={() => onSelect(item.key)}
          />
        ))}
      </div>

      {/* <button
        className="vendor-account-settings-delete"
        onClick={() => onSelect("delete-account")}
        type="button"
      >
        <DeleteAccountIcon size={18} />
        <span>Delete Account</span>
      </button> */}
    </>
  );
}

export default AccountSettingsHome;
